import { http } from "../client";
export var updateTimetable = function (_a) {
    var id = _a.id, title = _a.title, entries = _a.entries;
    var data = {
        id: id,
        title: title,
        entries: entries.map(function (entry) {
            var _a;
            return ({
                id: entry.id,
                title: (_a = entry.title) !== null && _a !== void 0 ? _a : "",
                days_enabled: entry.daysEnabled,
                time_start: entry.timeStart,
                time_end: entry.timeEnd,
                timetable_program_id: entry.rulesetId,
                strict_order: entry.strictOrder,
                interrupt_playing: entry.interruptPlaying,
            });
        }),
    };
    return http.api.put("timetables/".concat(id), data);
};
